import React, { useEffect, useState } from "react";
import AddUser from "./AddUser";
import UserList from "./UserList";
import "./User.css";

const User = () => {
  const [activeTab, setActiveTab] = useState("createUser");

  // Fetch user data when component mounts
  useEffect(() => {}, []);

  return (
    <div className="">
      <h4 className="mb-4 headStyle">Manage User</h4>
      <div className="headStyle">
        <ul className="nav nav-tabs mb-2 mt-3 mb-4">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "createUser" ? "active" : ""}`}
              onClick={() => setActiveTab("createUser")}
            >
              Create User
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "userList" ? "active" : ""}`}
              onClick={() => setActiveTab("userList")}
            >
              User List
            </button>
          </li>
        </ul>

        {activeTab === "createUser" && <AddUser />}

        {activeTab === "userList" && <UserList />}
      </div>
    </div>
  );
};

export default User;
